export default "__VITE_ASSET__CIYRECvz__"